import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "flag-icons/css/flag-icons.min.css";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;

// Só envolve com o provider do Google se o client id estiver no .env. Sem ele,
// o app funciona normal e o botão "Entrar com Google" simplesmente não aparece.
const AppTree = GOOGLE_CLIENT_ID
  ? (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  )
  : <App />;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {AppTree}
  </React.StrictMode>,
);
